export default "__VITE_ASSET__DYsODkbd__"